import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Popper from '../Popper'
import Box from '../Box'
import ClickOutsideListener from '../ClickOutsideListener'

export const TooltipTrigger = styled.span`
  cursor: pointer;
`

export const TooltipContent = styled.div`
  background-color: ${props => props.theme.tooltip.backgroundColor};
  box-shadow: 0px 16px 40px rgba(6, 20, 40, 0.55);
  border: 1px solid ${props => props.theme.tooltip.borderColor};
  border-radius: 4px;
  color: #e9edf1;
  padding: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  max-width: 350px;
  margin: 5px;
  white-space: normal;
  word-spacing: normal;
`

export const Tooltip = ({ content, placement, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handler = () => {
    setIsOpen(true)
  }

  const formattedContent = typeof content === 'string'
    ? content.split('[BREAK]').map((chunk, i) => <Box key={i} mt={i > 0 ? '1em' : 0}>{chunk}</Box>)
    : content

  return (
    <ClickOutsideListener
      onClickOutside={e => setIsOpen(false)}
      mouseEvent={'mouseout'}
      touchEvent={'touchstart'}
    >
      <Popper
        content={<TooltipContent>{formattedContent}</TooltipContent>}
        placement={placement}
        isOpen={isOpen}
      >
        <TooltipTrigger onMouseOver={handler}>{children}</TooltipTrigger>
      </Popper>
    </ClickOutsideListener>
  )
}

Tooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placement: PropTypes.string,
}

export default Tooltip
